export default "__VITE_ASSET__659dc916__"